<script setup lang="ts">
import type { IconName } from './icons';

/**
 * Иконка из спрайта. Класс .ic (+ модификаторы ic-18/24/28, ic-fill) задаётся снаружи
 * или через проп size. Размер по умолчанию — из CSS (.ic = 20px).
 */
const props = withDefaults(
  defineProps<{
    name: IconName | string;
    size?: 18 | 20 | 24 | 28;
    fill?: boolean;
  }>(),
  { fill: false },
);

const sizeClass: Record<number, string> = {
  18: 'ic-18',
  20: '',
  24: 'ic-24',
  28: 'ic-28',
};
</script>

<template>
  <svg
    class="ic"
    :class="[props.size ? sizeClass[props.size] : '', { 'ic-fill': props.fill }]"
    aria-hidden="true"
  >
    <use :href="`#i-${props.name}`" />
  </svg>
</template>
